// Translation: Utility > Feedback (English)
export default Object.freeze({
	hint: 'Leave feedback!'
})
